import { FontAwesome5 } from '@expo/vector-icons';
import { preferredLanguageAtom } from '@openeducation/oe-it-jotai-atoms';
import { getFullTranslatedDateWithWeekday } from '@openeducation/oe-it-services';
import type { DayActivityProps } from '@openeducation/oe-it-shared-types';
import { secondaryFontFamily, styled } from '@openeducation/oe-it-themes';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity, View } from 'react-native';

import { Loading, OEText } from '../../atoms';
import { flex, mt } from '../../style-utils';
import { ActivityHistory } from '../activity-history/activity-history';

export const DayActivity = ({
  isLoading,
  clearDateSelecetd,
  data,
  date,
}: DayActivityProps) => {
  const { t } = useTranslation();
  const language = useAtomValue(preferredLanguageAtom);

  if (!language) {
    return null;
  }

  const dateFormatted = date
    ? getFullTranslatedDateWithWeekday(date, language).toUpperCase()
    : '';

  return (
    <>
      <View style={[mt(16), flex('flex-row', 'justify-content-between')]}>
        <TouchableOpacity
          style={[flex('flex-row', 'align-items-center')]}
          onPress={clearDateSelecetd}
        >
          <ArrowIcon name="chevron-left" />
          <StyledText>{t('hr2.common.back')}</StyledText>
        </TouchableOpacity>
        <StyledText>{dateFormatted}</StyledText>
      </View>
      {isLoading ? (
        <View
          style={[
            flex('align-items-center', 'justify-content-center', 'flex-1'),
          ]}
        >
          <Loading />
        </View>
      ) : (
        <ActivityHistory data={data} />
      )}
    </>
  );
};

const StyledText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.black,
  fontSize: 16,
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
}))``;

const ArrowIcon = styled(FontAwesome5).attrs(({ theme }) => ({
  color: theme.color.black,
  size: 12,
}))`
  padding-horizontal: 4px;
`;
